import React, { useEffect, useRef, useState } from "react";
import "./HeroSearch.css";
import heroBg from "../../assets/harmon1.jpg";
import heroBg1 from "../../assets/harmon2.jpg";
import heroBg2 from "../../assets/loftone.webp"
const carouselImages = [
  heroBg,
  heroBg1,
  heroBg2,
];

const Hero = () => {
  const [idx, setIdx] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const timerRef = useRef(null);

  const go = (n) => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setIdx((prev) => (prev + n + carouselImages.length) % carouselImages.length);

    setTimeout(() => setIsTransitioning(false), 800);
  };

  const goTo = (n) => {
    if (isTransitioning || n === idx) return;

    setIsTransitioning(true);
    setIdx(n);

    setTimeout(() => setIsTransitioning(false), 800);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      alert(`Searching for: ${searchQuery}`);
      // Implement actual search logic here
    }
  };

  useEffect(() => {
    timerRef.current = setInterval(() => go(1), 5000);
    return () => clearInterval(timerRef.current);
  }, []);

  const pause = () => clearInterval(timerRef.current);
  const resume = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => go(1), 5000);
  };

  return (
    <section
      className="hero-section"
      aria-label="Featured properties in Tacoma"
      onMouseEnter={pause}
      onMouseLeave={resume}
    >
      {/* Background: stacked slides */}
      <div className="hero-background" role="presentation">
        {carouselImages.map((src, i) => (
          <div
            key={i}
            className={`hero-slide ${i === idx ? "is-active" : ""}`}
            aria-hidden={i !== idx}
          >
            <img src={src} alt="" className="hero-image" />
          </div>
        ))}
        <div className="hero-overlay" />
      </div>

      {/* Fixed foreground content */}
      <div className="hero-content">
        <div className="hero-text">
          <h1>Welcome to the Historic Harmon
          </h1>
          <p> Modern Amenities in an Iconic Tacoma Landmark</p>

          {/* Search bar */}

        </div>

        {/* Controls */}
        <div className="hero-controls" aria-label="Slideshow controls">
          <button
            className="hero-nav hero-nav--prev"
            onClick={() => go(-1)}
            aria-label="Previous slide"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="hero-dots" role="tablist" aria-label="Choose slide">
            {carouselImages.map((_, i) => (
              <button
                key={i}
                className={`hero-dot ${i === idx ? "is-active" : ""}`}
                onClick={() => goTo(i)}
                role="tab"
                aria-selected={i === idx}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
          <button
            className="hero-nav hero-nav--next"
            onClick={() => go(1)}
            aria-label="Next slide"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
